import { createFileRoute } from "@tanstack/react-router"
import { organizationSettingsViewStaticData } from "src/views/OrganizationSettingsView/constants"
import { OrganizationSettingsView } from "src/views/OrganizationSettingsView/OrganizationSettingsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/organization/")({
	component: OrganizationSettingsView,
	staticData: organizationSettingsViewStaticData,
})
